var Locations = {

    get: function (country, callback) {
        $.ajax({
            url: '/api/locations?country_id=' + country + '&allowed_only=1',
            method: 'GET',
            success: function (results) {
                callback(results);
            },
            error: function () {
                callback();
            }
        });
    }

};

module.exports = Locations;